/* eslint-disable */
import React, { useState, useEffect } from "react";

import { withStyles } from "@material-ui/core/styles";

import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import ProgressButton from "react-progress-button";

import { useSnackbar } from "react-simple-snackbar";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const InvoiceModal = ({ setOpen, open, sendPdf, frStatus, enStatus }) => {
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <form>
        <Dialog
          onClose={(e, reason) => {
            if (reason !== "backdropClick") {
              handleClose();
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            style={{ paddingLeft: "20px", color: "white" }}
          >
            Download PDF
          </DialogTitle>
          <DialogContent dividers>
            <div>
              <ProgressButton
                onClick={() => sendPdf("en")}
                state={enStatus}
                onSuccess={() => openSnackbar("Invoice sent successfully")}
              >
                Download PDF English
              </ProgressButton>

              <ProgressButton onClick={() => sendPdf("fr")} state={frStatus}>
                Download PDF French
              </ProgressButton>
            </div>
          </DialogContent>
        </Dialog>
      </form>
    </div>
  );
};

export default InvoiceModal;
